<template>
    <div class="openCaller">
        <!-- 导航栏 -->
        <topHead>
            <h3 slot="header">{{ navigationBarTitle }}</h3>
        </topHead>
        <!-- 内容 -->
        <div class="main">
            <div class="title">
                <h3>{{ packageInfo.title }}</h3>
            </div>
            <p>{{ packageInfo.detail }}</p>
            <van-button round type="info" @click="show = true"
                >立即开通</van-button
            >
        </div>
        <Popup :show="show" @showClick="closeClick(show)">
            <div class="conter" slot="conter">
                <p class="up">您即将开通{{ navigationBarTitle }}业务</p>
                <p class="low">每月资费￥{{ packageInfo.postage }}</p>
            </div>
            <div class="bottom" slot="bottom">
                业务资费将在您的当前可用余额中扣除
            </div>
            <div class="btn" slot="btn">
                <van-button round type="info" class="back" @click="show = false"
                    >取消</van-button
                >
                <van-button round type="info" class="pay" @click="goPay"
                    >确定</van-button
                >
            </div>
        </Popup>
    </div>
</template>

<script>
import topHead from "../../../components/topHead.vue"
import Popup from "../../../components/Popup.vue"
import { Popup as VantPopup,Toast } from "vant"
import API from "../../../common/api/api"
export default {
    name: "openCaller",
    data() {
        return {
            show: false,
            navigationBarTitle: "",
            typeList: ["漏电提醒", "来电显示"],
            type: "",
            packageInfo: "",
        }
    },
    created() {
        this.$nextTick(() => {
            this.type = this.$route.query.type
            //获取导航条标题
            this.navigationBarTitle = this.typeList[this.type - 1]
            // //获取套餐列表
            this.getPackageList()
        })
    },
    mounted() {},
    components: {
        topHead,
        Popup,
        "van-popup": VantPopup,
    },
    methods: {
        closeClick(show) {
            this.show = !show
        },
        goPay() {
            this.show = false
            API.getJson("PACKAGE_ORDER", {
                packageId: this.packageInfo.packageId,
            }).then(res => {
                console.log("来电显示的数据", res)

                if (res.code == 1) {
                    this.$router.replace({ path: "packageOpenSuccess" })
                } else if (res.data.code == -100) {
                    Toast({
                        message: res.data.msg,
                        position: "bottom",
                    })
                }
            })
        },
        //获取套餐列表
        getPackageList() {
            let that = this
            API.getJson("PACKAGE_LIST", { type: that.type }).then(res => {
                that.packageInfo = res.list[0]
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.main {
    padding: 0 px2rem(30);
}
.title {
    line-height: px2rem(75);
    font-size: px2rem(30);
    color: #f4d51f;
}
.main p {
    font-size: px2rem(26);
    color: #333333;
    line-height: px2rem(48);
    margin-bottom: px2rem(15);
}
.van-button {
    display: flex;
    justify-content: center;
    text-align: center;
    width: px2rem(550);
    height: px2rem(80);
    line-height: px2rem(80);
    color: #4d4d4d;
    font-weight: bold;
    font-size: px2rem(28);
    background-color: #ffff1a;
    margin: px2rem(180) auto 0;
    box-shadow: 0 0 px2rem(10) rgba($color: #000000, $alpha: 0.2);
}
.conter {
    font-size: px2rem(30);
    font-weight: 700;
    text-align: center;
}
.conter .up {
    color: #333;
}
.conter .low {
    color: #ff7505;
    margin-top: px2rem(10);
}
.bottom {
    // border-top: 1px solid #909198;
    font-size: px2rem(24);
    color: #909198;
    line-height: px2rem(80);
    text-align: center;
    margin-top: px2rem(40);
}
.btn {
    display: flex;
    justify-content: space-around;
}
.btn .van-button {
    width: px2rem(210);
    margin: 0;
}
.btn .back {
    background-color: #ffff80;
    color: #808080;
}
</style>